import { render } from "./professional.vue?vue&type=template&id=5de782ec"
import script from "./professional.vue?vue&type=script&lang=js"
export * from "./professional.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__